<template>
  <div>
    <form-header
      :form-name="formData.name"
      :is-submitting="isSubmitting"
      @save="handleSave"
      @back="back"
    />
    <div class="form-content">
      <div class="form-c-inner">
        <a-tabs
          :active-key="activeKey"
          :animated="false"
          @change="handleChange"
        >
          <a-tab-pane
            key="1"
            :force-render="true"
          >
            <span slot="tab">
              {{ $t('message["695"]') }}
              <i
                v-if="configFormError"
                class="iconfont iconicon-test34 tab-error-icon"
              />
            </span>
            <config-form
              v-if="permissions && Object.keys(permissions).length"
              ref="configForm"
              :permissions="permissions"
            />
          </a-tab-pane>
          <a-tab-pane
            key="2"
            :force-render="true"
          >
            <span slot="tab">
              {{ $t('message["261"]') }}
              <i
                v-if="compareFieldError"
                class="iconfont iconicon-test34 tab-error-icon"
              />
            </span>
            <compare-field ref="compareField" />
          </a-tab-pane>
        </a-tabs>
      </div>
    </div>
    <!-- <compare-field
      ref="compareField"
      style="display: none"
    /> -->
    <config-success-modal
      ref="successModal"
      :save-result="saveResult"
    />
    <leave-tip-dialog
      ref="leaveTip"
      @leavelHandler="leavelHandler"
    >
      <div slot="tip-slot">
        {{ $t('message["158"]') }}，<br>
        {{ $t('message["919"]') }}？
      </div>
    </leave-tip-dialog>
  </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import FormHeader from '@/components/pc/universalForm/FormHeader'
import ConfigForm from './ConfigForm'
import CompareField from './CompareField'
import ConfigSuccessModal from './ConfigSuccess'
import LeaveTipDialog from '@/components/pc/LeaveTipDialog'
import { universalOutSave } from '@/services/universalForm'

export default {
  components: {
    FormHeader,
    ConfigForm,
    CompareField,
    ConfigSuccessModal,
    LeaveTipDialog
  },

  data () {
    return {
      activeKey: '1',
      saveResult: '',
      count: 0,
      leave: {},
      status: false,
      hasSumbit: false,
      isSubmitting: false
    }
  },

  computed: {
    ...mapState('universalForm/outform', ['formData', 'confrimConfig', 'configFormError', 'compareFieldError', 'result', 'permissions']),
    formid () {
      return this.$route.query.formid || 0
    },
    tab () {
      return this.$route.query.tab || '1'
    }
  },
  watch: {
    formData: {
      handler (val) {
        if (val) {
          this.count++
          if (this.count > 1 && !this.hasSumbit) {
            this.removeClick()
            this.addClick()
          } else {
            this.removeClick()
          }
        }
      },
      deep: true
    },
    hasSumbit (val) {
      if (val) {
        this.removeClick()
      }
    },
    tab: {
      handler (val) {
        this.activeKey = val + ''
      },
      immediate: true
    }
  },

  async created () {
    await this.getData()
    await this.getUniversalPermissions()

    this.setConfigFormError(false)
    this.setCompareFieldError(false)
  },

  beforeRouteLeave (to, from, next) {
    if (this.count > 1 && !this.hasSumbit) {
      if (this.status) {
        this.removeClick()
        next()
        return
      }
      this.$refs.leaveTip.changeLimitDialog(true)
      this.leave = to
      next(false)
    } else {
      this.removeClick()
      next()
    }
  },

  methods: {
    ...mapActions('universalForm/outform', ['fetchFormData', 'getUniversalPermissions']),
    ...mapMutations('universalForm/outform', ['setConfigFormError', 'setCompareFieldError']),
    async getData () {
      const chain = await this.fetchFormData()
      chain
        .params({
          formid: this.formid,
          type: 2
        })
        .fetch()
    },
    handleChange (key) {
      console.log(key)
      this.activeKey = key
      this.$router.push({
        query: {
          ...this.$route.query,
          tab: key
        }
      })
    },
    async handleSave (name) {
      let res1 = await (this.$refs.compareField && this.$refs.compareField.handleSubmit())
      await (this.$refs.configForm && this.$refs.configForm.handleSubmit())

      this.result.formid = this.formData.formid
      this.result.name = name
      this.result.type = 2

      this.result.deploy = {}
      this.result.deploy.config = this.confrimConfig
      this.result.config = this.formData.config

      setTimeout(async () => {
        if (res1 && !this.configFormError && !this.compareFieldError) {
          this.isSubmitting = true
          let chain = await universalOutSave()
          chain
            .params(this.result)
            .onSuccess((res = {}) => {
              this.$refs.successModal && this.$refs.successModal.showModal()
              this.saveResult = res.content
              this.hasSumbit = true
            })
            .onNetSuccess(raw => {
              this.isSubmitting = false
            })
            .fetch()
        }
      }, 100)
    },
    back () {
      this.$router.push({ name: 'smartForm' })
    },
    leavelHandler (b) {
      const { leave } = this
      if (b) {
        this.status = true
        this.$router.push({ name: leave.name })
      } else {
        this.status = false
      }
      this.$refs.leaveTip.changeLimitDialog(false)
    },
    addClick () {
      window.onbeforeunload = function (e) {
        return false
      }
    },
    removeClick () {
      window.onbeforeunload = null
    }
  }
}
</script>
<style lang="scss" scoped>
.form-content::v-deep {
  width: 1278px;
  border: 1px solid #ebebeb;
  background: #fff;
  border-radius: 4px;
  margin: 24px auto 32px;

  .ant-tabs-nav {
    margin-left: 12px;
    .ant-tabs-tab {
      padding: 12px;
    }
  }
  .ant-tabs-bar {
    margin-bottom: 0;
  }
  .tab-error-icon {
    color: #f00;
  }
}
</style>
